/**
 * Shared time-window enum for reclaim win-rate aggregations
 * (`getReclaimWinRateByReason`, `getReclaimWinRateByBank`, ...). Lives in its
 * own file so multiple schema files can import without circular deps.
 */
export const reclaimWinRateTimeWindow = [
  "week",
  "twoWeeks",
  "month",
  "allTime",
] as const;

export type ReclaimWinRateTimeWindow =
  (typeof reclaimWinRateTimeWindow)[number];
